import { createBrowserRouter, Navigate } from 'react-router-dom';
import PortalShell from './components/PortalShell';
import Dashboard      from './pages/Dashboard';
import Profile        from './pages/Profile';
import Missions       from './pages/Missions';
import MissionCRA     from './pages/MissionCRA';
import Payments       from './pages/Payments';
import Referral       from './pages/Referral';
import Account        from './pages/Account';

export const router = createBrowserRouter([
  {
    path: '/',
    Component: PortalShell,
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: 'dashboard',                Component: Dashboard },
      { path: 'profile',                  Component: Profile },
      { path: 'missions',                 Component: Missions },
      { path: 'missions/:id/cra',         Component: MissionCRA },
      { path: 'payments',                 Component: Payments },
      { path: 'referral',                 Component: Referral },
      { path: 'account',                  Component: Account },
      { path: '*', element: <Navigate to="/dashboard" replace /> },
    ],
  },
]);
